import { useMemo } from "react";
import { useSelector } from "react-redux";

import { usePrintCenter } from "./usePrintCenter";
import { usePrintLayers } from "./usePrintLayers";
import { usePrintRectangle } from "./usePrintRectangle";
import { usePrintSettings } from "./usePrintSettings";
import { useProjectTitle, useProjectSrid, useProjectView, useProjectBaseMapName } from "../../../ducks/project/hooks";
import { getPrintTitle, getPrintWithTitle } from "../../../ducks/print/selectors";
import { useDefaultScaleRange } from "../../../hooks/style/useDefaultScaleRange";
import { PrintFile, PrintInfo } from "../../../interfaces/print";

export const usePrintInput = (printFile: PrintFile): PrintInfo => {
  const rectangle = usePrintRectangle();
  const settings = usePrintSettings();
  const mapCenter = usePrintCenter();
  const printLayers = usePrintLayers();
  const projectTitle = useProjectTitle();
  const printTitle = useSelector(getPrintTitle);
  const titleEnabled = useSelector(getPrintWithTitle);
  const title = titleEnabled ? printTitle || projectTitle : null;
  const srid = useProjectSrid();
  const baseMapName = useProjectBaseMapName();
  const { resolution } = useProjectView();
  const defaultScaleRange = useDefaultScaleRange();

  return useMemo(
    () => ({
      layers: printLayers,
      rectangle,
      srid,
      mapCenter,
      baseMapName,
      resolution,
      printFile,
      settings,
      title,
      defaultScaleRange,
    }),
    [printLayers, rectangle, srid, mapCenter, baseMapName, resolution, printFile, settings, title, defaultScaleRange],
  );
};
